<template functional>
  <div class="bumpmap-logo">
    <img class="emblem" src="/img/logo/emblem-dark.png" alt="bumpmap">
    <img class="logo-text" src="/img/logo/bumpmap.svg" alt="bumpmap">
  </div>
</template>

<script>
export default {
  name: 'Logo',
}
</script>

<style>
</style>
